import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
export function HeroSection() {
  const {
    t
  } = useLanguage();
  return <section className="relative min-h-[70vh] md:min-h-[90vh] h-auto flex items-start overflow-hidden" data-id="element-224">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-225">
        <img src="https://cdn.magicpatterns.com/uploads/oa5tF97CyYwzP5bMPijEJz/banner_new.png" alt="Tratamiento facial relajante" className="w-full h-full object-cover object-center" data-id="element-226" />
        {/* Overlay for text readability */}
        <div className="absolute inset-0 bg-gradient-to-b from-brand-charcoal/80 via-brand-charcoal/50 to-transparent h-[75%] md:h-[65%]" data-id="element-227"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full pt-6 pb-8 md:pt-24 md:pb-0 flex flex-col items-center text-center md:items-start md:text-left" data-id="element-228">
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="max-w-3xl flex flex-col items-center md:items-start" data-id="element-229">
          <span className="inline-block py-1 px-3 rounded-full bg-brand-gold/20 border border-brand-gold/30 text-brand-gold-light md:text-sm font-medium tracking-wider mb-4 md:mb-6 uppercase text-[14px]" data-id="element-230">
            {t('hero.badge')}
          </span>

          <h1 className="md:text-5xl lg:text-6xl font-serif text-white mb-4 md:mb-6 drop-shadow-lg text-[24px]" data-id="element-231">
            {t('hero.title1')}
            <br data-id="element-232" />
            {t('hero.title2')}
          </h1>

          <p className="text-sm md:text-xl text-brand-cream mb-5 md:mb-10 max-w-2xl font-light leading-relaxed" data-id="element-233">
            {t('hero.subtitle')}
          </p>

          <div className="flex flex-row gap-4" data-id="element-234">
            <a href="https://wa.me/15513328938?text=Hola%2C%20me%20gustar%C3%ADa%20reservar%20una%20cita" target="_blank" rel="noopener noreferrer" className="inline-flex justify-center items-center bg-brand-gold hover:bg-brand-gold-light text-white px-4 py-2.5 md:px-8 md:py-4 rounded-sm font-medium text-sm md:text-lg transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5" data-id="element-235">
              {t('hero.bookNow')}
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}